import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  NEWS_LIST,
  NEWS_DELETE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, NOPAGINATE, NEWS_DELETED } from "../../constant/constant";
import { toast } from "react-toastify";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link, useNavigate } from "react-router-dom";
import { Modal, Image } from "react-bootstrap";
import Select from "react-select";
import "jspdf-autotable";

const NewsList = () => {
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  // const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;
  const { hasPermission } = usePermission();

  const navigate = useNavigate();
  const HandleDelete = async (newsId) => {
    try {
      axios
        .delete(NEWS_DELETE + newsId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(NEWS_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/news");
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.error(err.response.data.msg);
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };

  /**
   * @API News List API's call
   */
  useEffect(() => {
    setLoading(true);
    axios
      .get(NEWS_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.news);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);
  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">News</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">News List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              {hasPermission("news-create") && (
                <div className="pt-btn">
                  <Link to={"/news/create"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard">
          {/* <div className="card-header">
            <h5>News List</h5>
          </div> */}

          <div className="container-fluid f_containter">
            <div className="row mb-4">

              {hasRole([1]) &&
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6]) &&
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6, 7]) &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectRegionRef}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              }

              {hasRole([1, 6, 7, 2]) &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) => {
                        setFilter({
                          ...filter,
                          chapter_id: selected?.value,
                        });
                      }}
                    />
                  </div>
                </div>
              }

            </div>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>News Image</th>
                  <th>Title</th>
                  {/* <th>Description</th> */}
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="10" />
                ) : data.length > 0 ? (
                  data.map((news, i) => (
                    <tr key={i}>
                      <td>{news?.sno}</td>
                      <td>
                        <a href={news?.image_path} target="_blank" rel="noopener noreferrer">
                          <Image
                            width={120}
                            height={80}
                            src={news?.image_path}
                          />
                        </a>
                      </td>
                      <td>{news?.title}</td>
                      {/* <td style={{ width: "50%", wordWrap: "break-word", whiteSpace: "normal" }}>
                        {news?.description?.length > 250
                          ? news.description.slice(0, 250) + "..."
                          : news.description}
                      </td> */}
                      {hasRole([1]) && <td>{news?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{news?.state_name}</td>}
                      {hasRole([1, 6, 7]) && <td>{news?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && <td>{news?.chapter_name}</td>}
                      <td style={{ textAlign: "right" }}>
                        {hasPermission("news-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(news);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}
                        {hasPermission("news-edit") && (
                          <Link to={`/news/${news.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("news-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(news?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="10" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#420203"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            News Details{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Title</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.title)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Description</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.description)}
                  </span>
                </div>
              </div>

              {hasRole([1]) &&
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Country</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.country_name)}
                    </span>
                  </div>
                </div>
              }

              {hasRole([1, 6]) &&
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">State</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.state_name)}
                    </span>
                  </div>
                </div>
              }

              {hasRole([1, 6, 7]) &&
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Region</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.region_name)}
                    </span>
                  </div>
                </div>
              }

              {hasRole([1, 6, 7, 2]) &&
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Chapter</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.chapter_name)}
                    </span>
                  </div>
                </div>
              }

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">News Creation Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.created_at)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">News Image</label>
                  <span className="d-block font-weight-600">
                    <a href={detailData?.image_path} target="_blank" rel="noopener noreferrer">
                      <Image
                        width={120}
                        height={80}
                        src={detailData?.image_path}
                      />
                    </a>
                  </span>
                </div>
              </div>

              {detailData.video_path && detailData.video_path.includes("youtube.com") && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">News Url</label>
                    <iframe
                      width="100%"
                      height="215"
                      src={`https://www.youtube.com/embed/${new URLSearchParams(new URL(detailData.video_path).search).get("v")}`}
                      title="YouTube video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              )}

            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default NewsList;
